import { AuthUser, UserStatus } from 'interfaces/user';
import { logout } from 'services/auth';
import CompleteRegistration from './CompleteRegistration';
import InactiveAccount from './InactiveAccount';
import PendingReview from './PendingReview';

const getOnboardingState = (user: AuthUser | null) => {
  if (user?.status === undefined || [UserStatus.Shortlisted, UserStatus.PendingApproval].includes(user?.status)) {
    return <PendingReview />;
  }
  if (user?.status === UserStatus.Registering) {
    return <CompleteRegistration />;
  }

  if (user?.status === UserStatus.Inactive) {
    return <InactiveAccount />;
  }
  if (user?.status === UserStatus.Rejected) {
    logout();
  }
  return undefined;
};

export default getOnboardingState;
